import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints, HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from 'styles/style-constants';

// Keep the footer below the fold while route chunks or page data are loading.
export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    min-height: calc(100vh - ${HEADER_HEIGHT});

    ${respondDown(Breakpoints.md)`
        min-height: calc(100vh - ${HEADER_HEIGHT_MOBILE});
    `}
`;
